"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BillboardNavigation", {
  enumerable: true,
  get: function get() {
    return _BillboardNavigation["default"];
  }
});
Object.defineProperty(exports, "GetFieldDictionary", {
  enumerable: true,
  get: function get() {
    return _generateFieldDictionary["default"];
  }
});
exports.propTypes = exports.defaultProps = exports["default"] = void 0;

require("raf/polyfill");

var _propTypes = require("prop-types");

var _BillboardNavigation = _interopRequireDefault(require("./BillboardNavigation"));

var _Form = _interopRequireDefault(require("./Form"));

var _generateFieldDictionary = _interopRequireDefault(require("./generateFieldDictionary"));

var _reactRedux = require("react-redux");

var _react = _interopRequireDefault(require("react"));

var _reducers = _interopRequireDefault(require("./reducers"));

var _styledReactModal = require("styled-react-modal");

var CuriousPanda = function CuriousPanda(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactRedux.Provider, {
    store: _reducers["default"]
  }, /*#__PURE__*/_react["default"].createElement(_styledReactModal.ModalProvider, null, /*#__PURE__*/_react["default"].createElement(_Form["default"], props)));
}; // exporting the defaultProps and propTypes
// so that we can use them in export.js
// which is the entry file for npm


var defaultProps = {
  perPageValidation: false,
  forceUnregisterOnUnmount: true,
  destroyOnUnmount: true,
  form: "unnamed_form",
  scrollToTop: true,
  fieldSpacing: 0,
  children: false,
  id: undefined,
  disabled: false,
  autoFocus: true
};
exports.defaultProps = defaultProps;
var propTypes = {
  components: (0, _propTypes.shape)({
    display: _propTypes.object,
    field: _propTypes.object,
    fields: _propTypes.object,
    fieldArray: _propTypes.object,
    raw: _propTypes.object
  }),
  participant: (0, _propTypes.shape)({
    enrollment_identifier: _propTypes.string,
    participant_auth_token: _propTypes.string
  }),
  autoComplete: _propTypes.string,
  autoFocus: _propTypes.bool,
  perPageValidation: _propTypes.bool,
  page: _propTypes.number,
  form: _propTypes.string.isRequired,
  schema: _propTypes.array.isRequired,
  onSubmit: _propTypes.func.isRequired,
  validate: _propTypes.func,
  asyncValidate: _propTypes.func,
  enableReinitialize: _propTypes.bool,
  keepDirtyOnReinitialize: _propTypes.bool,
  updateUnregisteredFields: _propTypes.bool,
  forceUnregisterOnUnmount: _propTypes.bool,
  destroyOnUnmount: _propTypes.bool,
  scrollToTop: _propTypes.bool,
  editableInterface: _propTypes.object,
  editableFields: _propTypes.array,
  handlePageChange: _propTypes.func,
  onModifySchema: _propTypes.func,
  fieldSpacing: _propTypes.number,
  children: _propTypes.func.isRequired,
  id: _propTypes.string,
  disabled: _propTypes.bool
};
exports.propTypes = propTypes;
CuriousPanda.defaultProps = defaultProps;
CuriousPanda.propTypes = propTypes;
var _default = CuriousPanda;
exports["default"] = _default;